/**
 * Normalización de transportadoras para procesos Envía.com (manual cron, cancel, etc.)
 */

export type EnviaComManualCarrier =
  | 'interRapidisimo'
  | 'deprisa'
  | 'coordinadora'
  | 'noventa9Minutos'

/** Claves normalizadas permitidas en el proceso manual (plataforma Envía.com, sin carrier "envia") */
const ALLOWED_CANONICAL = new Set<EnviaComManualCarrier>([
  'interRapidisimo',
  'deprisa',
  'coordinadora',
  'noventa9Minutos',
])

/**
 * Normaliza texto: minúsculas, sin tildes, espacios → guión bajo
 */
export function normalizeTransportadoraKey(
  value: string | null | undefined
): string {
  if (value == null || typeof value !== 'string') {
    return ''
  }
  return value
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, '_')
    .replace(/-/g, '_')
}

/**
 * Carrier Envía directo / Colvanes corporativo (excluido del manual Envía.com)
 */
export function isExcludedEnviaCarrier(value: string | null | undefined): boolean {
  const key = normalizeTransportadoraKey(value)
  if (!key) {
    return false
  }
  if (key === 'envia' || key === 'envia_com' || key === 'enviacom') {
    return true
  }
  return key.startsWith('envia_') || key === 'envia_colvanes'
}

/**
 * Resuelve transportadora a carrier Envía.com del proceso manual, o null si no aplica
 */
export function getEnviaComManualCarrierCanonical(
  value: string | null | undefined
): EnviaComManualCarrier | null {
  if (!value || isExcludedEnviaCarrier(value)) {
    return null
  }

  const key = normalizeTransportadoraKey(value)
  if (!key) {
    return null
  }

  if (
    key === 'inter_rapidisimo' ||
    key === 'interrapidisimo' ||
    (key.includes('inter') && key.includes('rapidi'))
  ) {
    return 'interRapidisimo'
  }

  if (key === 'deprisa') {
    return 'deprisa'
  }

  if (key === 'coordinadora') {
    return 'coordinadora'
  }

  if (
    key === 'noventa9minutos' ||
    key === 'noventa_9_minutos' ||
    key === '99minutos' ||
    key === '99_minutos' ||
    (key.includes('99') && key.includes('minut'))
  ) {
    return 'noventa9Minutos'
  }

  return null
}

export function isAllowedEnviaComManualCarrier(
  value: string | null | undefined
): boolean {
  const canonical = getEnviaComManualCarrierCanonical(value)
  return canonical !== null && ALLOWED_CANONICAL.has(canonical)
}
